import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

export const getHosptalDetails = (hospitalId: string) =>
  apiLoaderInstance.get(
    URL.GET_HOSPITAL_BASIC_INFO.replace('{id}', hospitalId)
  );
